export default "__VITE_ASSET__t63knwyf__"